document.querySelectorAll('.bg-special-wrapper').forEach((wrapper) => {
  const cardElementCount = wrapper.querySelectorAll('.card-cornered').length;
  const bgLeftElementCount = wrapper.querySelectorAll('.bg-left').length;

  if (cardElementCount > 2 && bgLeftElementCount > 0) {
    wrapper.querySelectorAll('.row > div:first-child .card-cornered').forEach((corneredCard) => {
      corneredCard.classList.add('corner-primary-dark');
    });
  }
});
